import React from 'react';

import '@schedule-x/theme-default/dist/index.css'
import Calendar from './Calendar';
import PopUpEditor from './PopUpEditor';

function CalendarApp({prizes, query}) {

  const [selectedDate, setSelectedDate] = React.useState(null);

  console.log("CalendarApp", prizes);

  return (
    <>
      <div style={{width: "100%", marginTop: '40px', marginBottom: '40px'}}>
        <Calendar prizes={prizes} onDateSelect={setSelectedDate}/>
      </div>
      {
        selectedDate && <PopUpEditor query={query} total_prizes={prizes} prizes={getPrizesDistributionByDay(prizes)} date={selectedDate} setDate={setSelectedDate}/>
      }
    </>
  )
}

function getPrizesDistributionByDay(prizes){
  return prizes;
}

export default CalendarApp